import { render, staticRenderFns } from "./namecardStyle.vue?vue&type=template&id=60e08450&scoped=true"
import script from "./namecardStyle.vue?vue&type=script&lang=js"
export * from "./namecardStyle.vue?vue&type=script&lang=js"
import style0 from "./namecardStyle.vue?vue&type=style&index=0&id=60e08450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e08450",
  null
  
)

export default component.exports